// extracted by mini-css-extract-plugin
export default {"p":"StatisticItem_p__9vjqi","statisticItem":"StatisticItem_statisticItem__6bVR4"};